const benefits = [
  { icon: 'ri-money-dollar-circle-line', title: 'Lower Energy Bills', desc: 'Reduce your electricity costs with the right solar and battery combination.' },
  { icon: 'ri-battery-charge-line', title: 'Understand Battery Payback', desc: 'Clear ROI analysis so you know exactly when your battery investment pays off.' },
  { icon: 'ri-star-line', title: 'Compare Trusted Providers', desc: 'Side-by-side comparisons of verified installers with real customer reviews.' },
  { icon: 'ri-bank-card-line', title: 'Explore Finance Options', desc: 'Access green loans, payment plans and rebate information in one place.' },
  { icon: 'ri-line-chart-line', title: 'Future Energy Optimisation', desc: 'Prepare for smart energy management, time-of-use optimisation and VPP participation.' },
];

export default function ForHomes() {
  return (
    <section id="homes" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <span className="inline-block px-3.5 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-xs font-semibold tracking-wider uppercase text-primary-700 mb-5">
              For Homeowners
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight mb-4" style={{ color: '#111827' }}>
              Smarter Energy Choices For
              <span className="relative ml-2" style={{ color: '#2FA84F' }}>
                Australian Homes
              </span>
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
              Find solar, batteries, EV charging and smart home energy solutions with clearer comparisons, trusted providers and better guidance.
            </p>

            <div className="space-y-3 mb-8">
              {benefits.map((b) => (
                <div key={b.title} className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${b.icon} text-primary-500 text-sm`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{b.title}</h4>
                    <p className="text-xs text-foreground-600 mt-0.5">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              Start Your Home Energy Enquiry
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20modern%20Australian%20family%20home%20with%20sleek%20black%20solar%20panels%20on%20terracotta%20roof%20and%20a%20white%20Tesla%20Powerwall%20battery%20on%20the%20exterior%20wall%20electric%20SUV%20charging%20in%20driveway%20manicured%20garden%20with%20native%20Australian%20plants%20sunny%20day%20blue%20sky%20lifestyle%20photography%20warm%20natural%20lighting&width=1000&height=800&seq=homes-visual&orientation=landscape"
                alt="Australian family home with solar panels, battery storage, and EV charging"
                className="w-full h-auto rounded-2xl"
                loading="lazy"
              />
            </div>

            <div className="absolute -bottom-4 -left-4 bg-white rounded-xl px-4 py-3 flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-sun-line text-accent-500 text-xl"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">Average Annual Savings</p>
                <p className="text-lg font-bold" style={{ color: '#F4D13D' }}>$1,200 - $2,400</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}